import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RestApiService } from '../rest-api.service';
import { NotifierService } from 'angular-notifier';
import { MessageService } from '../message.service';
import * as CryptoJS from 'crypto-js';
// const CryptoJS = require("crypto-js");



@Component({
    selector: 'app-login-lt',
    templateUrl: './login-lt.component.html',
    styleUrls: ['./login-lt.component.css']
})
export class LoginLTComponent implements OnInit {
    loginName: string;
    password: string;
    private respObject: any;
    private notifier: NotifierService;
    clientSelected: string;
    clients: any;
    clientId: number;
    map: any;

    constructor(private route: Router, private _rest: RestApiService, notifier: NotifierService, private messageService: MessageService) {
        this.notifier = notifier;
    }

    ngOnInit() {
        this.loginName = '';
        this.password = '';
        const userId = this.messageService.getUserId();
        const token = this.messageService.getToken();
        // this.clients = [];
        // this.map = {};
        // this.messageService.setClientId(1);
        // this._rest.getLoginClientList().subscribe((res) => {
        //     this.respObject = res;
        //     if (this.respObject.success) {
        //         this.clients = this.respObject.clients;
        //         for (let i = 0; i < this.clients.length; i++) {
        //             console.log(" id == >>> " + this.clients[i].id + ', clientCode == >>> ' + this.clients[i].clientCode);
        //             this.map[this.clients[i].clientCode] = this.clients[i].id;
        //         }
        //         console.log(" == >>> " + JSON.stringify(this.map));
        //     }
        // }, (err) => {
        // });

        if (userId !== null && userId !== undefined && token !== null && token !== undefined) {
            this._rest.getUserdetails(userId).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.clientId = this.respObject.details[0].clientId;
                    if (this.respObject.details.clientId === 1) {
                        this.route.navigate(['admin/module']);
                    } else {
                        // this.route.navigate(['user/dashboard']);
                    }
                } else {
                    this.messageService.clearSession();
                }
            }, (err) => {
            });
        } else {
            this.messageService.clearSession();
        }
        this.clientSelected = '';


    }



    login() {
        //  const secretKey = "$$&iFIX&^%$TEchglobalpvt@#!1598753ltsEncryption&De00987scryption";
        //  const encryptedpass = this.password;
        //  const encryptedPassword = CryptoJS.AES.encrypt(encryptedpass, secretKey).toString();

        // const data = {
        //     loginName: this.loginName,
        //     clientCode: this.clientSelected,
        //     password: encryptedPassword
        // };


        const data = {
            loginName: this.loginName,
            clientCode: this.clientSelected,
            password: this.password
        };


        if (!this.messageService.isBlankField(data)) {
            this.messageService.clearSession(); 

            // console.log(this.clientSelected.toLowerCase() + " -- " + this.map[this.clientSelected.toLowerCase()]);
            // this.messageService.setClientId(this.map[this.clientSelected.toLowerCase()]);
            // this.messageService.setClientCode(this.clientSelected);

            this._rest.loginlt(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    // this.messageService.addSessionData(this.respObject.details.id + '', this.respObject.details.token);
                    const clientId = this.respObject.details.clientId;
                    const userId = this.respObject.details.id;
                    const encodedId = btoa(this.messageService.xorEncode(userId + '', this.messageService.SECRET_TOKEN));
                    console.log(typeof clientId, clientId);
                    if (clientId === 1) {
                        this.messageService.addSessionData(this.respObject.details.id + '', this.respObject.details.token, clientId);
                        this.route.navigate(['admin/module']);
                    } else {
                        // this.messageService.changeRouting(this.respObject.details.dashboard);
                        window.location.href = this.respObject.details.dashboard
                            + '?userId=' + encodedId + '&token=' + this.respObject.details.token + '&clientId='
                            + clientId;
                    }
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else {
            this.notifier.notify('error', this.messageService.BLANK_ERROR_MESSAGE);
        }
    }
}
